export default function Aida () {
    return (
        <div>
        <h2 className="gap-1 flex">
          The DISGENET AI assistant, AIDA
          <img src="../../static/images/eyesAida.svg" alt="bot-aida" width="40" height="40" className="ml-1" />
        </h2>
        <div className="mb-2 divider" />
        <p>
          It combines the power of generative AI with the capabilities of the DISGENET REST API. You can ask
          questions in natural language and the assistant will translate them to structured queries to the
          database exploiting all the features available in DISGENET, and summarize the main results for you.
          The DISGENET AI assistant lowers the barrier to access DISGENET for users with no programming skills
          and no knowledge about DISGENET data schema. Try it{' '}
          <a href="/Assistant" target="_blank">
            here
          </a>
          .
        </p>
      </div>
    )
}